var T = /* @__PURE__ */function (t) {
  return t.LEFT = "left", t.RIGHT = "right", t.TOP = "top", t.BOTTOM = "bottom", t;
}(T || {});
export { T };